import React from 'react';

import card1Image from './images/card1.png';
import card2Image from './images/card2.png';
import card3Image from './images/card3.png';
import card4Image from './images/card4.png';
import css from './SectionWhatYouGet.module.css';
import { FormattedMessage } from 'react-intl';


const SectionWhatYouGet = props => {

    return (
        <div className={css.root}>

            <p className={css.title}>
                <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.title" />
            </p>
            <div className={css.horizontalWrapperWrapAt50}>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card1Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card1.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card1.info" />
                    </p>
                </div>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card2Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card2.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card2.info" />
                    </p>
                </div>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card3Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card3.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card3.info" />
                    </p>
                </div>

                <div className={css.cardWrapperFlexWrap}>
                    <img className={css.cardImage} src={card4Image} />
                    <p className={css.cardTitle}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card4.title" />
                    </p>
                    <p className={css.cardInfo}>
                        <FormattedMessage id="LandingProfessionalsPage.SectionWhatYouGet.card4.info" />
                    </p>
                </div>

            </div>
        </div>

    );
};

export default SectionWhatYouGet;
